import React, { memo } from 'react';
import { Panel, PanelHeader, PanelBody } from '../../../components/panel/panel.jsx';
import FormNews from './components/FormNews.js';

const NewsCreate = (props) => {
  return (
    <div>
      <h1 className="page-header">News Create</h1>
      <div className="row">
        <div className="col-xl-12">
          <Panel>
            <PanelHeader>Information</PanelHeader>
            <PanelBody>
              <FormNews action="create" />
            </PanelBody>
          </Panel>
        </div>
      </div>
    </div>
  );
};

export default memo(NewsCreate);
